import {RouteProps} from 'config/navigation';
import {MdCreditCard} from 'react-icons/md';

import DeliveryManBillings from './delivery-man-billings';
import DeliveryManBillingDetails from './delivery-man-billing-details';

const deliveryManBillingsPages: RouteProps = {
  name: 'Faturas (Entregadores)',
  path: 'delivery-man-billings',
  permission: 'deliveryManBillings.findAll',
  icon: <MdCreditCard />,
  subRoutes: [
    {
      path: '',
      element: <DeliveryManBillings />,
      permissions: ['deliveryManBillings.findAll'],
    },
    {
      path: ':id',
      element: <DeliveryManBillingDetails />,
      permissions: ['deliveryManBillings.findOne'],
      wrapper: false,
      hideDrawer: true,
    },
  ],
};

export default deliveryManBillingsPages;
